import { ReactNode } from 'react';
import { Logo } from '../../assets';
import { cx } from '@/utils/cx';

interface SignUpLayoutProps {
    children: ReactNode;
}

export function SignUpLayout({ children }: SignUpLayoutProps) {
    return (
        <div className='flex flex-col min-h-screen gap-4 items-center'>
            {/* <div className='flex items-center justify-center w-full h-[86px] px-8 py-2.5
                            border-b border-gray-20 bg-white'>
                <Logo.PaySftLogo />
            </div> */}
            <div className="flex w-full px-4 pb-6 h-[calc(100vh-104px)] ">
                
                    {children}

                
            </div>
        </div>

    );
}